import { render, staticRenderFns } from "./ConfirmResetPasswordComponent.vue?vue&type=template&id=8e8bebb0&scoped=true&"
import script from "./ConfirmResetPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8bebb0",
  null
  
)

export default component.exports